import withConfirmationDialog from './withConfirmationDialog';

const withDeletePopup = WrappedComponent =>
  withConfirmationDialog({
    title: 'Delete item',
    message: 'Are you sure you want to delete this item?',
    onDialogOpenPropName: 'onDeleteConfirmationDialogOpen',
  })(WrappedComponent);

export default withDeletePopup;
